import { useEffect, useState } from 'react';

const InventoryStockLevel = (props: any) => {
  const { rowData, mixIns } = props;
  const [value, setValue] = useState(String(rowData._onHand ?? ''));
  const [valid, setValid] = useState(true);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const nextValue = e.target.value;
    setValue(nextValue);
    if (nextValue === '') {
      mixIns.clearStock(rowData._id);
      setValid(true);
      return;
    }
    const numericValue = Number(nextValue);
    if (Number.isFinite(numericValue) && e.target.reportValidity()) {
      mixIns.updateStock(rowData._id, numericValue);
      setValid(true);
    } else {
      mixIns.clearStock(rowData._id);
      setValid(false);
    }
  };

  const revertValue = () => {
    if (!valid) {
      setValue(String(rowData._onHand ?? ''));
      setValid(true);
    }
  };

  const stockPercentageColor = () => {
    if (rowData._preferredStockLevel && rowData._preferredStockLevel > 0) {
      const percentage = rowData._onHand / rowData._preferredStockLevel;
      if (percentage > 0.8) {
        return 'green';
      } else if (percentage > 0.4) {
        return 'yellow';
      } else {
        return 'red';
      }
    }
    return '';
  };

  useEffect(() => {
    if (!mixIns.isEditing) {
      return;
    }
    setValue(String(rowData._onHand ?? ''));
    setValid(true);
  }, [mixIns.isEditing]);

  return (
    <div className="stock-input-container" onClick={(e) => e.stopPropagation()}>
      {mixIns.isEditing ? (
        <>
          <input
            type="number"
            onChange={(e) => {
              handleChange(e);
            }}
            onBlur={() => {
              if (mixIns.autoSave && valid && value !== '') {
                mixIns.onCommit?.(rowData._id, Number(value));
              }
              mixIns.onStopEditing?.();
              revertValue();
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                if (mixIns.autoSave && valid && value !== '') {
                  mixIns.onCommit?.(rowData._id, Number(value));
                }
                mixIns.onStopEditing?.();
                revertValue();
              }
              if (e.key === 'Escape') {
                mixIns.onStopEditing?.();
                revertValue();
              }
            }}
            onClick={(e) => e.stopPropagation()}
            value={value}
            min="0"
            step="1"
            className={`table-input ${!valid ? ' invalid' : ''}`}
            data-testid="inventory-stock-input"
            required
          />
          {rowData._preferredStockLevel && (
            <span className="preferred-stock">/{rowData._preferredStockLevel}</span>
          )}
        </>
      ) : (
        <>
          <span
            className={`indicator ${stockPercentageColor()}`}
            onClick={(e) => {
              e.stopPropagation();
              mixIns.onStartEditing?.(rowData._id);
            }}
            style={{ cursor: mixIns.onStartEditing ? 'pointer' : 'default' }}
          >
            <span>{rowData._onHand}</span>
            {rowData._preferredStockLevel != null && <span> /{rowData._preferredStockLevel}</span>}
          </span>
        </>
      )}
    </div>
  );
};

export default InventoryStockLevel;
